import { render, staticRenderFns } from "./CmgCheckout.vue?vue&type=template&id=47b1862b&scoped=true&lang=pug&"
import script from "./cmg-checkout.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckout.vue?vue&type=style&index=0&id=47b1862b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1862b",
  null
  
)

export default component.exports